import {ILoraForwarderLoriotService} from '@/services/lora/forwarder/ILoraForwarderLoriot.service';

import {LoraForwarderStdService} from '@/services/lora/forwarder/LoraForwarderStd.service';
import {injectable} from 'inversify-props';

@injectable()
export class LoraForwarderLoriotService extends LoraForwarderStdService implements ILoraForwarderLoriotService {

  constructor() {
    super('/lora/forwarder/loriot-packet-forwarder');
  }

  public async getNetworkServerAddress(): Promise<string> {
    return this.apiService.get(`${this.path}/network-server/address`);
  }

  public async setNetworkServerAddress(address: string): Promise<void> {
    return this.apiService.post(`${this.path}/network-server/address`, address);
  }

  public async getNetworkServerPort(): Promise<string> {
    return this.apiService.get(`${this.path}/network-server/port`);
  }

  public async setNetworkServerPort(port: string): Promise<void> {
    return this.apiService.post(`${this.path}/network-server/port`, port);
  }
}
